module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.0-141.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.9.0.md
// module id = 558
// module chunks = 229